import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import {
  SlDrawer,
  SlButton,
  SlInput,
  SlIcon,
  SlOption,
  SlSelect,
  SlDialog,
  SlProgressBar,
} from "@shoelace-style/shoelace/dist/react";
import { useNavigate } from "react-router";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import { formatDate, formatDateYYYYMMDD } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import { roles, langoptions, clusters, pxToCm } from "../../utils/constants";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Datepicker from "react-tailwindcss-datepicker";
import { CSVLink } from "react-csv";
import NoImage from "../../assets/images/NoImage.png";
import EditIcon from "../../assets/images/edit_icon.svg";
import UserIcon from "../../assets/images/user_icon.svg";
import LocationSVG from "../../assets/images/location.svg";
import { Modal } from "react-bootstrap";
import filterSvg from "../../assets/images/filter.svg";
import { debounce } from "../../utils/Debounce";
import Select from "react-select";
import AsyncSelect from "react-select/async";

function AlphaBirdview() {
  const navigate = useNavigate();
  const [flag, setFlag] = useState("");
  const [show, setShow] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [progress, setProgress] = useState(0);
  const [id, setId] = useState("");
  const [date,setDate] = useState("");
  const [preview, setPreview] = useState(false);
  const [advDetails, setAdvDetails] = useState([]);
  const [estimatedValue, setEstimatedValue] = useState(0);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [downloadData, setDownloadData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedBrandType, setSelectedBrandType] = useState("0");
  const [newspapers, setNewspapers] = useState([{ label: "Eenadu", value: "Eenadu" }]);
  const [locations, setLocations] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [userType, setUserType] = useState("");
  const [imgSrc, setImgSrc] = useState("");
  const [merge, setMerge] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [brands, setBrands] = useState([]);
  const [imgUrl, setImgUrl] = useState("");
  const [recentInsertedBirdview, setRecentInsertedBirdview] = useState();
  const [editions, setEditions] = useState([]);
  const [newspaperLocations, setNewspaperLocations] = useState([]);
  const [newspaperLocationsObject, setNewspaperLocationsObject] = useState([]);
  const [fileName, setFileName] = useState("");
  const observer = useRef();
  const [infLoader, setInfLoader] = useState(false);
  const [newspaperData, setNewsPaperData] = useState([]);
  const csvLinkRef = useRef();
  const [showDialog, setShowDialog] = useState(null);
  const [uploadImage, setUploadImage] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [clusterOptions, setClusterOptions] = useState([]);
  const [clusterLoading, setClusterLoading] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [adFormats, setAdFormats] = useState([]);
  const [pageTypes, setPageTypes] = useState([]);
  const [editRecord, setEditRecord] = useState(null);
  const [showOriginalUrl, setShowOriginalUrl] = useState(false);
  const [selectedCategory,setSelectedCategory] = useState([])
  const [selectedSubCategory,setSelectedSubCategory] = useState([])
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [position, setPosition] = useState({ x: 50, y: 50 });
  const imgRef = useRef(null);

  const zoomLevel = 5;

  const handleMouseMove = (e) => {
    const elem = imgRef.current;
    if (!elem) return;

    const { top, left, width, height } = elem.getBoundingClientRect();
    const x = ((e.pageX - left - window.pageXOffset) / width) * 100;
    const y = ((e.pageY - top - window.pageYOffset) / height) * 100;

    // Allow zooming even beyond edges (0-100% can become negative or >100%)
    setPosition({ x, y });
  };
  let defaultFirstBirdView = {
    lang_id: -1,
    edition: "",
    ad_format: "",
    newspaper_name: "",
  };

  const [firstBirdView, setfirstBirdView] = useState(defaultFirstBirdView);

  const {
    handleSubmit,
    register,
    control,
    formState: { errors,isSubmitting },
    setValue,
    watch,
    reset,
  } = useForm();

  const watchEdition = watch("edition");
  const watchLanguage = watch("language");
  const watchAdFormat = watch("ad_format");
  const watchNewspaperName = watch("newspaper_name");
  const watchLocation = watch("location");
  const watchCluster = watch("cluster");
  const watchPageType = watch("page_type");
  const watchCategory = watch("category_id");
  const watchSubCategory = watch("sub_category_id");
  const watchColor = watch("color");
  const colorOptions = [ { label: "B&W", value:0 }, {label:"Color", value:1}];

  const findSelectOption = (options = [], match) => {
    if (!match) return null;
    const normalized = match?.toString().toLowerCase();
    return (
      options.find(
        (option) =>
          option?.value?.toString().toLowerCase() === normalized ||
          option?.label?.toString().toLowerCase() === normalized
      ) || null
    );
  };

  const buildBrandOption = (brandId, brandLabel) => {
    if (brandId === undefined || brandId === null || brandId === "") return null;
    return {
      value: brandId,
      label: brandLabel || `${brandId}`,
    };
  };

  const initialObject = {
    id: "",
    person_name: "",
    relation: "",
    contact: "",
    address: "",
  };

  const relations = [
    { id: 1, name: "Father" },
    { id: 2, name: "Mother" },
    { id: 3, name: "Son" },
    { id: 4, name: "Daughter" },
    { id: 5, name: "Others" },
    { id: 6, name: "Husband" },
    { id: 7, name: "Wife" },
  ];

  const formattedRelations = relations.map((relation) => ({
    value: relation.id,
    label: relation.name,
  }));
  const [inputFields, setInputFields] = useState([ initialObject]);
  const locationObject = useMemo(() => {
    const obj = {};
    newspaperLocationsObject.forEach((location) => {
      obj[location.value] = location.label;
    });
    return obj;
  }, [newspaperLocationsObject]);

  const getLocations = (locations) => {
    if (!locations) {
      return "";
    }
    if (!Array.isArray(locations)) {
      locations = [locations];
    }
    let location_names = [];
    for (const location of locations) {
      location_names.push(locationObject[location]);
    }
    if (location_names.length > 0) return location_names.join(", ");
    return "";
  };

  const loadNewspaperLocations = async (edition) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      if (!edition) {
        setNewspaperLocations([]);
        return [];
      }
      const response = await api({
        url: `/eenenadupagerates/getlocations`,
        method: "POST",
        responseType: "json",
        data: { location_type: edition,newspaper:watchNewspaperName?.label || watchNewspaperName?.value},
      });
      if (response?.code === 200 && Array.isArray(response?.data)) {
        setNewspaperLocations(response.data);
        setNewspaperLocationsObject((prev) => {
          const existing = new Map((prev || []).map((item) => [item.value, item]));
          response.data.forEach((item) => {
            existing.set(item.value, item);
          });
          return Array.from(existing.values());
        });
        setLocations(response.data)
        return response.data;
      } else {
        toast.error(response?.data?.message);
        return [];
      }
    }
    return [];
  };

  const onSubmit = async (data) => {
    if (flag === "add") {
      try {
        let res = await api({
          url: `/birdview/addalpha`,
          method: "POST",
          responseType: "json",
          data: {
            ad_format: data?.ad_format?.label,
            brand_type: "Alpha",
            campaign_name: data?.campaign_name,
            date: data?.date,
            edition: data?.edition?.value,
            estimated_value: data.estimated_value,
            language: data?.language?.value,
            newspaper_name: data?.newspaper_name?.label || data?.newspaper_name?.value,
            page_no: data?.page_no,
            location: data?.location?.value,
            page_type: data?.page_type?.value,
            upload_url: imgUrl,
            contact_details: data?.phone_numbers,
            location_details: data?.location_details,
            person_names: data?.person_names,
            category_id: data.category_id?.value,
            sub_category_id: data?.sub_category_id?.value,
            brand_id: data?.brand_name?.value || null,
            advertisers: JSON.stringify(inputFields),
          },
        });
        if (res?.code !== 200) {
          Toast("error", res?.data?.message);
        } else {
          handleClose();
          reset();
          setCurrentPage(0);
          setSearch("");
          setFlag("");
          loadData(search, 0, dateRange, selectedNewspaper, userType);
          loadNewspapers(watchLanguage?.value);
          setDefaultDate();
          Toast("success", "AlphaBirdview Added Successfully");
          setImgUrl("");
          setInputFields([initialObject]);
        }
      } catch (error) {
        Toast("error", "Something went Wrong");
      }
    }
    if (flag === "edit") {
      const safeRecord = editRecord || {};
      const estimatedVal = safeRecord?.estimated_value ?? data?.estimated_value;
      if (!estimatedVal) {
        Toast("info","Estimated Value Not Found, close and open again");
        return;
      }
      try {
        let res = await api({
          url: `/birdview/editalpha`,
          method: "POST",
          responseType: "json",
          data: {
            ad_format: data?.ad_format?.label,
            brand_type: safeRecord?.brand_type ?? "Alpha",
            campaign_name: data?.campaign_name,
            date: data?.date,
            edition: data?.edition?.value,
            estimated_value: data?.estimated_value,
            language: safeRecord?.language ?? data?.language?.value,
            newspaper_name: safeRecord?.newspaper_name ?? (data?.newspaper_name?.label || data?.newspaper_name?.value),
            page_no: safeRecord?.page_no ?? data?.page_no,
            location: [data?.location?.value],
            page_type: data?.page_type?.value,
            upload_url: imgUrl || safeRecord?.image_url || "",
            contact_details: safeRecord?.contact_details ?? data?.phone_numbers,
            location_details: safeRecord?.location_details ?? data?.location_details,
            person_names: safeRecord?.person_names ?? data?.person_names,
            id: id,
            category_id: data.category_id?.value,
            sub_category_id: data?.sub_category_id?.value,
            brand_id: data?.brand_name?.value,
            advertisers: JSON.stringify(inputFields),
            dimensions:{...editRecord?.dimensions,price_per_unit:estimatedValue?.price_per_unit,color:watchColor?.value}
          },
        });
        if (res?.status !== "SUCCESS") {
          Toast("error", res?.data?.message);
        } else {
          reset();
          setFlag("");
          setCurrentPage(0);
          loadData(search, 0, dateRange, selectedNewspaper, userType);
          setfirstBirdView(defaultFirstBirdView);
          Toast("success", "AlphaBirdview Edited Successfully");
          handleClose();
          setInputFields([initialObject]);
          setImgUrl("");
        }
      } catch (error) {
        Toast("error", "Something went wrong");
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const handleAdd = () => {
    if (flag === "edit") {
      return;
    }
    if (inputFields.length < 10) {
      setInputFields([
        ...inputFields,
        {
          id: "",
          person_name: "",
          relation: "",
          contact: "",
          address: "",
        },
      ]);
    } else {
      Toast("error", "Maximum limit of 10 contacts exceeded");
    }
  };

  const handleRemove = (index) => {
    if (flag === "edit") {
      return;
    }
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleDateRange = (selectedDate) => {
    setData([]);
    setCurrentPage(0);
    if (selectedDate) {
      if (selectedDate.startDate && selectedDate.endDate) {
        setDateRange(selectedDate);
      } else {
        setDateRange({ startDate: null, endDate: null });
      }
    } else {
      setDateRange({ startDate: null, endDate: null });
    }
  };

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const AdFormatOptions = Array.isArray(adFormats) ? adFormats : [];

  const handleClose = () => {
    reset();
    setValue("brand_name", null);
    setValue("edition", null);
    setValue("ad_format", null);
    setValue("page_type", null);
    setValue("location", []);
    setValue("cluster", []);
    setValue("sub_category_id", null);
    setDefaultDate();
    setShow(false);
    setId("");
    setfirstBirdView(defaultFirstBirdView);
    loadSubCategories(selectedCategory?.value)
    setEditRecord(null);
    setShowOriginalUrl(false);
  };
  useEffect(()=>{
     loadCategories();
  },[])
  const handleShow = async (choose, item) => {
    const adFormatOptionsData = await loadAdFormats(item?.newspaper_name);
    const pageTypeOptionsData = await loadPageTypes(item?.newspaper_name);
    if (choose === "add") {
      setEditRecord(null);
      setInitialRender(false);
      const selectedLanguage =
        langoptions.find((option) => option.value === recentInsertedBirdview?.language) ||
        langoptions.find((option) => option.label.toLowerCase() === "telugu");
      const editionOptions = await loadPageNames(selectedLanguage?.value);
      setValue("date", date);
      setValue("page_no", recentInsertedBirdview?.page_no);
      setValue(
        "ad_format",
        findSelectOption(adFormatOptionsData, recentInsertedBirdview?.ad_format)
      );
      setValue(
        "newspaper_name",
        newspapers.find((option) => option.value === recentInsertedBirdview?.newspaper_name) ||
          newspapers.find((option) => option.label?.toLowerCase() === recentInsertedBirdview?.newspaper_name?.toLowerCase())
      );
      setValue("language", selectedLanguage);
      setValue(
        "edition",
        findSelectOption(editionOptions, recentInsertedBirdview?.edition || recentInsertedBirdview?.page_name)
      );
      setValue(
        "page_type",
        findSelectOption(pageTypeOptionsData, recentInsertedBirdview?.page_type || recentInsertedBirdview?.page_name)
      );
      const location = findSelectOption(locations,item.location);
      setValue("location",location)
      setValue(
        "brand_name",
        buildBrandOption(recentInsertedBirdview?.brand_id, recentInsertedBirdview?.brand_name)
      );
      setValue(
        "brand_type",
        recentInsertedBirdview?.ad_type === "Finite"
          ? "finite"
          : recentInsertedBirdview?.ad_type === "Infinite"
          ? "infinite"
          : ""
      );
      setValue("sub_category_id", null);
      setFlag("add");
      setShow(true);
    }
    if (choose === "edit") {
      setEditRecord(item);
      setInitialRender(true);
      // Set basic fields
      setValue("date", formatDateYYYYMMDD(item?.date));
      const languageOption =
        langoptions.find((option) => option.value === item?.language) ||
        langoptions.find((option) => option.label.toLowerCase() === "telugu");
      setValue("language", languageOption);
      if(item.newspaper_name) setValue(
        "newspaper_name",
        newspapers.find((option) => option.value === item?.newspaper_name) ||
          newspapers.find((option) => option.label.toLowerCase() === "eenadu")
      );
      if(item.page_no) setValue("page_no", item.page_no);
      if(item.ad_format) setValue(
        "ad_format",
        findSelectOption(adFormatOptionsData, item?.ad_format)
      );
      if(item.page_type) setValue(
        "page_type",
        findSelectOption(pageTypeOptionsData, item?.page_type || item?.page_name)
      );
      setValue("color",colorOptions.find(option => option?.value === item?.dimensions?.color));
      if(item.estimated_value) setValue("estimated_value", item?.estimated_value);
      setValue("campaign_name", item?.campaign_name);
      const category = findSelectOption(categories,item.category);
      if(item.category) setValue("category_id",category);
      const loadedSubCategories = await loadSubCategories(category?.value || item?.category_id);
      const prefilledSubCategory = findSelectOption(
        loadedSubCategories,
        item?.sub_category_id || item?.sub_category
      );
      if (prefilledSubCategory) {
        setValue("sub_category_id", prefilledSubCategory);
      } else {
        setValue("sub_category_id", null);
      }
      if (item?.brand_id && item.brand_name){
          const brands = await loadBrands(item.brand_name) || [];
          console.log(brands)
          if(brands.length) setValue("brand_name",brands[0])
      }
      setValue("location_details", item.location_details);
      setValue("person_names", item.person_names);
      setValue("phone_numbers", item.contact_details);
      setValue(
        "brand_type",
        item?.ad_type === "Finite"
          ? "finite"
          : item?.ad_type === "Infinite"
          ? "infinite"
          : ""
      );
      setImgUrl(item?.image_url);
      setInputFields(JSON.parse(JSON.stringify(item.advertisers)));
      setEstimatedValue(item?.estimated_value);

      // Load newspaper locations and set location
      const getLocation = (edition) => {
          if (!edition) return "";
          let result = edition;
          const suffixes = ["districts Edition", "individual districts main Edition", "main Edition", "state clusters Edition"];
          
          for (const suffix of suffixes) {
              const regex = new RegExp(`${suffix}$`, "i");
              if (regex.test(result)) {
                  result = result.replace(regex, "").trim();
                  break;
              }
          }

          return result?.toLowerCase();
      };
      const getEdition = (str) => {
        if (!str) return "";

        const editions = ["individual districts main","state clusters","districts","main"];
        let cleaned = str.toLowerCase().replace(/edition$/i, "").trim();
        const sorted = editions.sort((a, b) => b.length - a.length);

        for (const ed of sorted) {
          const regex = new RegExp(`${ed}$`, "i");
          if (regex.test(cleaned)) {
            return ed; 
          }
        }
        return "";
      };
      const edition = getEdition(item.edition);
      setValue("edition",{ label:edition , value : edition});
      const location = getLocation(item.edition);
      setValue("location", {value:location,label:location});

      // // Load clusters if edition is district
      // if (item?.edition?.toLowerCase().includes("district") && Locations.length === 1) {
      //   setClusterLoading(true);
      //   const res = await api({
      //     url: "/birdview/getClusters",
      //     method: "POST",
      //     responseType: "json",
      //     data: { district: Locations[0].label },
      //   });
      //   if (res?.code === 200 && Array.isArray(res.data.clusters)) {
      //     const clusterOptions = res.data.clusters.map((c) => ({ label: c, value: c }));
      //     setClusterOptions(clusterOptions);
      //     const clusterLabels = item.clusters?.map((location) =>
      //       clusterOptions.find((option) => option.value === location)
      //     ).filter(Boolean) || [];
      //     setValue("cluster", clusterLabels);
      //   } else {
      //     setClusterOptions([]);
      //     setValue("cluster", []);
      //   }
      //   setClusterLoading(false);
      // } else {
      //   setClusterOptions([]);
      //   setValue("cluster", []);
      // }

      setShow(true);
      setFlag("edit");
      setId(item.id);
    }
  };

  const loadNewspapers = async (language) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_names`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200) {
        setNewspapers(response?.data?.result || [{ label: "Eenadu", value: "Eenadu" }]);
      } else {
        toast.error(response?.data?.message);
      }
    }
  };

  const loadAdFormats = async (newspaper) => {
    try {
      const response = await api({
        url: "/eenenadupagerates/getad_types",
        method: "POST",
        responseType: "json",
        data:{newspaper}
      });
      if (response?.code === 200 && Array.isArray(response?.data)) {
        setAdFormats(response.data);
        return response.data;
      } else {
        setAdFormats([]);
        return [];
      }
    } catch (error) {
      console.error("Error loading ad formats", error);
      setAdFormats([]);
      return [];
    }
  };

  const loadPageNames = async (language) => {
    if (!language) {
      setEditions([]);
      return [];
    }
    try {
      const response = await api({
        url: "/birdview/getPageNames",
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200 && Array.isArray(response?.data)) {
        setEditions(response.data);
        return response.data;
      } else {
        setEditions([]);
        return [];
      }
    } catch (error) {
      console.error("Error loading editions", error);
      setEditions([]);
      return [];
    }
  };

  const loadPageTypes = async (newspaper) => {
    try {
      const response = await api({
        url: "/eenenadupagerates/getpage_types",
        method: "POST",
        responseType: "json",
        data:{newspaper}
      });
      if (response?.code === 200 && Array.isArray(response?.data)) {
        setPageTypes(response.data);
        return response.data;
      }
      setPageTypes([]);
      return [];
    } catch (error) {
      console.error("Error loading page types", error);
      setPageTypes([]);
      return [];
    }
  };

  const fetchNewsPapers = async () => {
    try {
      let res = await api({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([...res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const loadData = async (
    search = "",
    page = 0,
    dateRange,
    selectedNewspaper,
    userType
  ) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      try {
        if (data?.length === 0) {
          setLoader(true);
        }

        const response = await api({
          url: `/birdview/getalpha`,
          method: "POST",
          responseType: "json",
          data: {
            BirdViewSearch: search,
            page,
            dateRange,
            selectedNewspaper: selectedNewspaper.length
              ? selectedNewspaper.map((item) => item.value)
              : [],
            userType,
            limit: 20,
            category:selectedCategory?.value,
            sub_category : selectedSubCategory?.value
          },
        });

        if (response?.code === 200) {
          if (infLoader) {
            setData((prevData) => [...prevData, ...response?.data?.res]);
          } else {
            setData(response?.data?.res);
          }
          setTotalPages(Math.ceil(response?.data?.totalCount / 20));
          setTotalRecords(response?.data?.totalCount);
          setRecentInsertedBirdview(response?.data?.latestRecord);
        } else {
          toast.error(response?.data?.message);
        }
      } catch (error) {
        toast.error("Failed to load data");
        console.error(error);
      } finally {
        setLoader(false);
        setInfLoader(false);
      }
    }
  };

  const loadCategories = async () => {
    try {
      let res = await api({
        url: "/birdview/alphacategory",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setCategories(res.data);
        return res.data;
      }
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const loadSubCategories = async (categoryId) => {
    setSubCategories([]);
    if (!categoryId) {
      return [];
    }
    try {
      setSubCategoryLoading(true);
      const res = await api({
        url: "/birdview/alphasubcategory",
        method: "POST",
        responseType: "json",
        data: { category_id: categoryId },
      });
      if (res?.code === 200 && Array.isArray(res?.data)) {
        setSubCategories(res.data);
        return res.data;
      }
      return [];
    } catch (error) {
      console.error("Error loading sub categories", error);
      return [];
    } finally {
      setSubCategoryLoading(false);
    }
  };

  const loadBrands = async (inputValue = "") => {
    if (!inputValue || inputValue.length < 3) {
      return [];
    }
    try {
      const response = await api({
        url: "/user/sales_persons/getBrands",
        method: "POST",
        responseType: "json",
        data: { search: inputValue },
      });
      if (response?.code === 200 && Array.isArray(response?.data)) {
        return response.data.map((item) => ({
          label: item?.label || item?.brand_name || item?.name || `${item?.value ?? item?.brand_id}`,
          value: item?.value || item?.brand_id || item?.id,
        }));
      }
      return [];
    } catch (error) {
      console.error("Error loading brands", error);
      return [];
    }
  };

  const DownloadBirdViewData = async (
    search = "",
    dateRange,
    selectedNewspaper
  ) => {
    try {
      setDownloadLoader(true);
      const response = await api({
        url: `/birdview/downloadBirdviewAlpha`,
        method: "POST",
        responseType: "json",
        data: {
          BirdViewSearch: search,
          dateRange,
          selectedNewspaper: selectedNewspaper.length
            ? selectedNewspaper.map((item) => item.value)
            : [],
          category:selectedCategory?.value,
          sub_category:selectedSubCategory?.value
        },
      });
      setDownloadLoader(false);
      if (response?.code === 200) {
        const data = response.data?.map((item) => ({
          ...item,
          date: formatDateYYYYMMDD(item?.date) || "",
          location: item?.location?.map((id) => getLocations(id) || []),
          width: item.dimensions?.w ?? "",
          height: item.dimensions?.h ?? "",
          area: item.dimensions?.area ?? "",
          color: item.dimensions?.color === 1 ? "Color" : item.dimensions?.color === 0 ? "B&W" : "",
          price_per_unit: item.dimensions?.price_per_unit ?? ""
        }));
        setDownloadData(data ? data : []);
      }
    } catch (error) {
      console.error("Error @ DownloadBirdViewData", error);
    }
  };

  useEffect(() => {
    if (downloadData.length) {
      csvLinkRef?.current?.link?.click();
      setDownloadData([]);
    }
  }, [downloadData]);

  useEffect(()=>{
    loadSubCategories(selectedCategory?.value);
  },[selectedCategory])

  useEffect(()=>{
    if(watchCategory?.value) loadSubCategories(watchCategory?.value);
  },[watchCategory])
  
  const imageChange = async (e) => {
    setFileName(e.target.files[0].name);
    if (e.target.files && e.target.files.length > 0) {
      if (
        e.target.files[0].type === "image/jpg" ||
        e.target.files[0].type === "image/jpeg" ||
        e.target.files[0].type === "image/webp" ||
        e.target.files[0].type === "image/png"
      ) {
        setUploadImage(e.target.files[0]);
      } else {
        Toast("error", "Only jpg, jpeg, webp, png formats accepted");
        setValue("upload_url", null);
      }
    } else {
      if (flag === "edit") {
        setImgUrl(imgUrl);
      } else {
        setProgress(0);
        setImgUrl("");
      }
    }
  };

  const formData = new FormData();
  formData.append("files", uploadImage);
  const imageUrl = async () => {
    try {
      let url = await api({
        url: `/upload/birdviewimage`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        setImgUrl(url.data.data);
        setUploadImage();
      } else {
        setProgress(0);
        setValue("upload_url", null);
        if (flag === "edit") setUploadImage("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  const loadEditions = async (language) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_editions`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200) {
        setEditions(response?.data?.result);
      } else {
        toast.error(response?.data?.message);
      }
    }
  };

  const getColors = (brand) => {
    const brandLookup = newspaperData.filter((np) => np.name === brand);
    return {
      backgroundColor: brandLookup[0]?.background_color,
      color: brandLookup[0]?.color,
    };
  };
  useEffect(()=>{
    if([watchEdition, watchLocation, watchAdFormat, watchPageType].some(f => !f?.value)) return;
    const getEstimatedValue = async()=> {
       const response = await api({
          url: `/eenenadupagerates/estimatedvalue`,
          method: "POST",
          responseType: "json",
          data: {
            location_type: watchEdition.value,
            ad_location: watchLocation?.value,
            page_type: watchPageType?.value,
            ad_type: watchAdFormat?.value,
            area: editRecord?.dimensions?.area,
            color: watchColor?.value,
            newspaper:watchNewspaperName?.lable || watchNewspaperName?.value
          },
        });
      if(response.status==="SUCCESS"){
         setValue("estimated_value",response.data.estimated_value);
         setEstimatedValue(response.data);
      }
    }
    getEstimatedValue();
 },[watchEdition,watchLocation,watchAdFormat,watchColor,watchPageType,editRecord])
  
  // const getEstimatedValue = async (
  //   language,
  //   edition,
  //   ad_format,
  //   newspaper_name,
  //   location,
  //   cluster,
  //   page_type
  // ) => {
  //   if (
  //     localStorage.getItem("role") === roles.b2b ||
  //     localStorage.getItem("role") === roles.salesperson
  //   ) {
  //     const response = await api({
  //       url: `/birdview/estimatedvalue`,
  //       method: "POST",
  //       responseType: "json",
  //       data: {
  //         lang_id: language,
  //         edition: edition,
  //         ad_format: ad_format,
  //         newspaper_name: newspaper_name,
  //         location: location?.value,
  //         page_type: page_type?.value || page_type || undefined,
  //       },
  //     });
  //     if (response?.code === 200) {
  //       if (
  //         !firstBirdView.edition &&
  //         flag !== "add"
  //       ) {
  //         let newBirdview = {
  //           lang_id: language || -1,
  //           edition: edition || "",
  //           ad_format: ad_format || "",
  //           newspaper_name: newspaper_name || "",
  //         };
  //         setfirstBirdView(newBirdview);
  //         setValue("estimated_value", estimatedValue);
  //       } 
  //       else {
  //         setValue("estimated_value", response?.data?.result?.estimated_value);
  //       }
  //     } else {
  //       toast.error(response?.data?.message);
  //     }
  //   }
  // };

  const getClusters = (labels = []) => {
    const locations = labels.length > 0 ? labels : watch("location");
    if (!locations) return [];

    const locationsLabels = locations?.map((location) => location.label);
    let clusterset = new Set();

    for (let location of locationsLabels) {
      let clusterValues = clusters[location];
      clusterValues?.forEach((val) => clusterset.add(val));
    }

    const clusterArray = Array.from(clusterset);

    return clusterArray.map((loc) => ({ label: loc, value: loc }));
  };

  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadData(search, 0, dateRange, selectedNewspaper, userType);
    }
  }, [search, dateRange, selectedNewspaper, userType, selectedCategory,selectedSubCategory]);

  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadPageNames(watchLanguage?.value);
    }
  }, [watchLanguage?.value]);


  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadNewspaperLocations(watchEdition?.value);
    }
  }, [watchEdition?.value ,watchNewspaperName?.value]);

  // // Modified useEffect to avoid resetting location and cluster when editing
  // useEffect(() => {
  //     setValue("location", []);
  //     setValue("cluster", []);
  // }, [watchEdition, flag, setValue]);

  // Reset clusters when district/location changes (but not in edit mode)
  // useEffect(() => {
  //     setValue("cluster", []);
  // }, [watchLocation, flag, setValue]);

  useEffect(() => {
    if (Array.isArray(watchLocation) && watchLocation.length === 1 && watchEdition?.value?.toLowerCase().includes("district")) {
      setClusterLoading(true);
      api({
        url: "/birdview/getClusters",
        method: "POST",
        responseType: "json",
        data: { district: watchLocation[0].label },
      })
        .then((res) => {
          if (res?.code === 200 && Array.isArray(res.data.clusters)) {
            setClusterOptions(res.data.clusters.map((c) => ({ label: c, value: c })));
          } else {
            setClusterOptions([]);
          }
        })
        .finally(() => setClusterLoading(false));
    } else {
      setClusterOptions([]);
    }
  }, [watchLocation, watchEdition]);

  const csvHeaders = [
    { label: "Category", key: "category" },
    { label: "Sub Category", key: "sub_category" },
    { label: "Campaign_Name", key: "campaign_name" },
    { label: "Estimated_Price", key: "estimated_value" },
    { label: "Page_No", key: "page_no" },
    { label: "Page_Name", key: "page_name" },
    { label: "Page Type", key: "page_type" },
    { label: "Ad_format", key: "ad_format" },
    { label: "Edition", key: "edition" },
    { label: "Location", key: "location" },
    { label: "Source", key: "source" },
    { label: "date", key: "date" },
    { label: "Newspaper_Name", key: "newspaper_name" },
    { label: "Image_url", key: "image_url" },
    { label: "Contacts", key: "contact_details" },
    { label: "Persons", key: "person_names" },
    { label: "Address", key: "location_details" },
    { label: "Clusters", key: "clusters" },
    { label: "Original_url", key: "original_url" },
    { label: "Width", key: "width" },
    { label: "Height", key: "height" },
    { label: "Area", key: "area" },
    { label: "Color", key: "color" },
    { label: "Price_Per_Unit", key: "price_per_unit" }
  ];

  const userDetails = async () => {
    if (localStorage.getItem("role") === roles.salesperson) {
      let headDetails = await api({
        url: `/birdview/userDetails`,
        method: "POST",
        responseType: "json",
      });
      if (headDetails.data) {
        const userData = headDetails?.data?.result;
        if (userData.user_type === -1) {
          setUserType("MainHead");
        } else if (
          userData.user_type === 1 &&
          userData.region === -1 &&
          userData.location === -1
        ) {
          setUserType("NationalHead");
        } else if (
          userData.user_type === 2 &&
          userData.region === -1 &&
          userData.location === -1
        ) {
          setUserType("LocalHead");
        } else if (
          userData.user_type === 1 &&
          userData.region !== -1 &&
          userData.location === -1
        ) {
          setUserType("RegionHead");
        } else if (
          userData.user_type === 1 &&
          userData.region !== -1 &&
          userData.location !== -1
        ) {
          setUserType("NationalUser");
        } else if (userData.user_type === 2 && userData.region !== -1) {
          setUserType("LocalUser");
        }
      }
    }
  };

  const [scrolltopdata, setscrolltopdata] = useState("");

  const setDefaultDate = () => {
      const prevDate = localStorage.getItem('alpha_birdview_date');
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const formattedToday = `${year}-${month}-${day}`;
      if(prevDate){
          setDate(prevDate);
      }
      else {
          localStorage.setItem('alpha_birdview_date',formattedToday);
          setDate(formattedToday);
      }
  };

  useEffect(() => {
    userDetails();
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 15) {
        setscrolltopdata("");
      } else {
        setscrolltopdata("scrolled");
      }
    });
  }, []);

  useEffect(() => {
    setDefaultDate();
  }, []);

  useEffect(() => {
    if (currentPage !== 0)
      loadData(search, currentPage, dateRange, selectedNewspaper, userType);
  }, [currentPage]);

  const lastItemRef = useCallback(
    (node) => {
      if (loader) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if (data?.length < totalRecords) {
            setInfLoader(true);
            setCurrentPage((prevPage) => prevPage + 1);
          }
        }
      });
      if (node) observer.current.observe(node);
    },
    [loader]
  );

  const searchFilterOnChange = (e) => {
    setSearch(e.target.value);
    setData([]);
    setCurrentPage(0);
  };

  useEffect(() => {
    if (uploadImage) {
      imageUrl();
    }
  }, [uploadImage]);

  return (
    <>
      <div
        className={`flex gap-2 justify-end mb-4 items-center stickyFilters ${scrolltopdata}`}
      >
        <div className="flex gap-4 justify-end mobHide">
          <div>
            <Select
              isClearable
              className=""
              placeholder="Select Category"
              name="category"
              size="medium"
              value={selectedCategory}
              onChange={(selected) => {
                setSelectedCategory(selected);
                setData([]);
                setCurrentPage(0);
              }}
              options={categories}
            />
          </div>
          <div>
            <Select
              isClearable
              className=""
              placeholder="Selected Sub Category"
              name="category"
              size="medium"
              value={selectedSubCategory}
              onChange={(selected) => {
                setSelectedSubCategory(selected);
                setData([]);
                setCurrentPage(0);
              }}
              options={subCategories}
            />
          </div>
          <div>
            <Select
              className=""
              placeholder="Select Newspaper"
              name="source"
              size="medium"
              value={selectedNewspaper}
              onChange={(selected) => {
                setSelectedNewspaper(selected || []);
                setData([]);
                setCurrentPage(0);
              }}
              options={[
                ...newspaperData
                  .filter((item) => item.name === "Eenadu")
                  .map((item) => {
                    return { label: item.name, value: item.name };
                  }),
              ]}
              isMulti
            />
          </div>

          <SlInput
            className="w-full"
            size="medium"
            placeholder="Newspaper/Edition/Adv Name "
            onSlInput={debounce(searchFilterOnChange, 500)}
            style={{ width: "230px" }}
          >
            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
          </SlInput>
          <div className="border rounded-lg min-w-fit h-fit">
            <Datepicker
              classNames="form-input "
              value={dateRange}
              primaryColor={"cyan"}
              showShortcuts={true}
              useRange={true}
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={handleDateRange}
            />
          </div>
        </div>
        <img
          src={filterSvg}
          alt="filter"
          onClick={() => setShowFilter(true)}
          className="w-6 mobileOnly"
        ></img>

        {localStorage.getItem("role") === roles.b2b ? (
          <>
            <CSVLink
              data={downloadData}
              headers={csvHeaders}
              filename={`birdview_data.csv`}
              ref={csvLinkRef}
            ></CSVLink>
            {downloadLoader ? (
              <TableLoader />
            ) : (
              <i
                className="bi bi-download px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150"
                data-toggle="tooltip"
                title="Download AlphaBirdview Data"
                onClick={() =>
                  DownloadBirdViewData(search, dateRange, selectedNewspaper)
                }
              ></i>
            )}
          </>
        ) : null}

        {/* {localStorage.getItem("role") === roles.b2b ? (
          <div>
            <SlButton
              variant="primary"
              size="small"
              onClick={() => {
                setInitialRender(false);
                handleShow("add");
                setFlag("add");
              }}
            >
              Add BirdView
            </SlButton>
          </div>
        ) : null} */}
      </div>
      <SlDrawer
        label={flag === "edit" ? "Edit BirdView" : "Add AlphaBirdview"}
        open={show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": "90vw", maxWidth: "1200px" }}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 h-full">
          {flag === "edit" && editRecord && (
            <div className="flex flex-col">
              <div className="mb-4">
                <p className="font-medium mb-2">
                  Ad Preview: {showOriginalUrl ? "Original Image" : "Cropped Image"}
                </p>
                <label className="flex items-center gap-3 cursor-pointer">
                  <span className="text-sm">Cropped</span>
                  <div
                    onClick={() => setShowOriginalUrl(!showOriginalUrl)}
                    className={`h-6 w-11 rounded-full p-1 transition ${showOriginalUrl ? 'bg-blue-600' : 'bg-gray-400' }`}
                  >
                    <div className={`h-4 w-4 bg-white rounded-full transition ${showOriginalUrl ? 'translate-x-5' : ''}`} />
                  </div>
                  <span className="text-sm">Original</span>
                </label>
              </div>

              <div className="flex-1 flex items-center justify-center bg-gray-50 rounded-lg overflow-hidden border">
                {showOriginalUrl && editRecord?.original_url ? (
                  <img
                    src={editRecord.original_url}
                    alt="Original upload"
                    className="max-w-full max-h-full object-contain"
                    onError={(e) => { e.target.src = NoImage; }}
                  />
                ) : editRecord?.image_url ? (
                  <img
                    src={editRecord.image_url}
                    alt="Processed ad"
                    className="max-w-full max-h-full object-contain"
                    onError={(e) => { e.target.src = NoImage; }}
                  />
                ) : (
                  <img src={NoImage} alt="No image" className="max-w-full max-h-full object-contain" />
                )}
              </div>

              <div className="mt-4 text-xs text-gray-600 space-y-1">
                <p><strong>Image URL:</strong> {editRecord.image_url || "N/A"}</p>
                <p><strong>Original URL:</strong> {editRecord.original_url || "N/A"}</p>
              </div>
            </div>
          )}
        <div className={`${flag === "edit" ? "overflow-y-auto" : ""}`}>
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            {/* Date Field */}
            <div className="mb-3">
              <label>Date</label>
              <span className="text-red-600">*</span>
              <input
                type="date"
                className="form-control"
                placeholder="Choose Date"
                disabled={flag === "edit"}
                {...register("date", {
                  required: "Date is required",
                  onChange: (e) => localStorage.setItem("alpha_birdview_date", e.target.value),
                })}
              />
              {submit && errors.date && (
                <div className="text-red-600">{errors.date.message}</div>
              )}
            </div>

            {/* Language */}
            <div className="mb-3">
              <label className="form-label">Language</label>
              <Controller
                name="language"
                control={control}
                rules={{ required: "Language is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="language"
                    placeholder="Select Language"
                    options={langoptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isDisabled={flag === "edit"}
                  />
                )}
              />
              {submit && errors.language && (
                <div className="text-red-600">{errors.language.message}</div>
              )}
            </div>

            {/* Newspaper Name */}
            <div className="mb-3">
              <label className="mb-1">Newspaper Name</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="newspaper_name"
                rules={{ required: "Newspaper Name is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="newspaper_name"
                    placeholder="Select Newspaper Name"
                    options={newspapers}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isDisabled={flag === "edit"}
                  />
                )}
              />
              {submit && errors.newspaper_name && (
                <div className="text-red-600">
                  {errors.newspaper_name.message}
                </div>
              )}
            </div>

            {/* Page Number */}
            <div className="mb-3">
              <label className="mb-1">Page Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Page Number"
                disabled={flag === "edit"}
                {...register("page_no")}
              />
              {submit && errors.page_no && (
                <div className="text-red-600">{errors.page_no.message}</div>
              )}
            </div>

            {/* Edition */}
            <div className="mb-3">
              <label className="form-label">Edition</label>
              <Controller
                name="edition"
                control={control}
                // rules={{ required: "Edition is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="edition"
                    placeholder="Select Edition"
                    options={editions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    // isDisabled={flag === "edit"}
                  />
                )}
              />
              {submit && errors.edition && (
                <div className="text-red-600">{errors.edition.message}</div>
              )}
            </div>



            {/* Location */}
                <div>
                  <label className="mb-1 mr-2">Location</label>
                  <Controller
                    control={control}
                    name="location"
                    render={({ field }) => (
                      <Select
                        {...field}
                        name="location"
                        placeholder="Select Location"
                        options={newspaperLocations}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        // isDisabled={flag === "edit"}
                      />
                    )}
                  />
                  {errors.location && (
                    <div className="text-red-600">{errors.location.message}</div>
                  )}
                </div>
                {/* {Array.isArray(watchLocation) && watchLocation.length === 1 && (
                  <div>
                    <label className="mb-1 mr-2">Cluster</label>
                    <Controller
                      control={control}
                      name="cluster"
                      render={({ field }) => (
                        <Select
                          {...field}
                          name="cluster"
                          placeholder={clusterLoading ? "Loading..." : "Select cluster"}
                          options={clusterOptions}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isMulti
                          isDisabled={clusterLoading}
                        />
                      )}
                    />
                    {errors.cluster && (
                      <div className="text-red-600">{errors.cluster.message}</div>
                    )}
                  </div>
                )} */}
            <div className="mb-3">
              <label className="form-label">Page Type</label>
              <Controller
                name="page_type"
                control={control}
                rules={{ required: "Page Type is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="page_type"
                    placeholder="Select Page Type"
                    options={pageTypes}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    // isDisabled={flag === "edit"}
                  />
                )}
              />
              {errors.page_type && (
                <div className="text-red-600">{errors.page_type.message}</div>
              )}
            </div>
            {/* Ad Format */}
            <div className="mb-3">
              <label className="mb-1">Ad Format</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="ad_format"
                rules={{ required: "Ad Format is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="ad_format"
                    placeholder="Select Ad Format"
                    options={AdFormatOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    // isDisabled={flag === "edit"}
                  />
                )}
              />
              {errors.ad_format && (
                <div className="text-red-600">{errors.ad_format.message}</div>
              )}
            </div>

            <div className="mb-3">
              <label className="mb-1">Category</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="category_id"
                rules={{ required: "Category is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="category_id"
                    placeholder="Select Category"
                    options={categories}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {errors.category_id && (
                <div className="text-red-600">{errors.category_id.message}</div>
              )}
            </div>

            <div className="mb-3">
              <label className="mb-1">Sub Category</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="sub_category_id"
                rules={{ required: "Sub Category is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="sub_category_id"
                    placeholder="Select Sub Category"
                    options={subCategories}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    isLoading={subCategoryLoading}
                    isDisabled={!subCategories.length}
                  />
                )}
              />
              {errors.sub_category_id && (
                <div className="text-red-600">{errors.sub_category_id.message}</div>
              )}
            </div>
            {/* Color */}
            <div className="mb-3">
              <label className="mb-1">Color</label>
              <span className="text-red-600">*</span>
              <Controller
                control={control}
                name="color"
                rules={{ required: "Color is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="color"
                    placeholder="Select Color"
                    options={colorOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    // isDisabled={flag === "edit"}
                  />
                )}
              />
              {errors.ad_format && (
                <div className="text-red-600">{errors.color.message}</div>
              )}
            </div>
            {/* Estimated Price */}
            <div className="mb-3">
              <label className="mb-1">Estimated Price</label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Estimated Price"
                aria-label="Estimated Price"
                readOnly
                {...register("estimated_value", {
                  required: "Estimated Price is required",
                })}
              />
              {errors.estimated_value && (
                <div className="text-red-600">
                  {errors.estimated_value.message}
                </div>
              )}
            </div>

            {/* Campaign Name Field */}
            <div className="mb-3">
              <label className="mb-1">Campaign Name</label>
              <span className="text-red-600">*</span>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Campaign Name"
                aria-label="Campaign Name"
                {...register("campaign_name", {
                  required: "Campaign Name is required",
                })}
              />
              {errors.campaign_name && (
                <div className="text-red-600">{errors.campaign_name.message}</div>
              )}
            </div>

            <div className="mb-3">
              <label className="mb-1">Brand</label>
              <Controller
                control={control}
                name="brand_name"
                render={({ field }) => (
                  <AsyncSelect
                    {...field}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadBrands}
                    placeholder="Search Brand"
                    isClearable
                  />
                )}
              />
            </div>

            <button
              type="button"
              name="add"
              className="btn btn-primary"
              onClick={() => handleAdd()}
              disabled={flag === "edit"}
            >
              Add
            </button>
            {Array.isArray(inputFields) &&
              inputFields?.map((_, index) => (
                <>
                  <div className="my-2">
                    <label className="mb-1">Person Name</label>
                    <Controller
                      control={control}
                      name={`person_name_${index}`}
                      render={({ field }) => (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Person Name"
                          {...field}
                          value={inputFields[index][`person_name`]}
                          disabled={flag === "edit"}
                          onChange={(e) => {
                            field.onChange(e);
                            const updatedFields = [...inputFields];
                            updatedFields[index] = {
                              ...updatedFields[index],
                              [`person_name`]: e.target.value,
                            };
                            setInputFields(updatedFields);
                          }}
                        />
                      )}
                    ></Controller>
                  </div>
                  <div className="my-2">
                    <label className="mb-1">Relation</label>
                    <Controller
                      control={control}
                      name={`relation_${index}`}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={formattedRelations}
                          placeholder="Select Relation"
                          className="basic-single-select"
                          classNamePrefix="select"
                          isDisabled={flag === "edit"}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption?.value);
                            const updatedFields = [...inputFields];
                            updatedFields[index] = {
                              ...updatedFields[index],
                              relation: selectedOption?.value || "",
                            };
                            setInputFields(updatedFields);
                          }}
                          value={formattedRelations.find(
                            (opt) => opt.value === inputFields[index]?.relation
                          )}
                        />
                      )}
                    />
                  </div>

                  <div className="my-2">
                    <label className="mb-1">Phone Number</label>
                    <Controller
                      control={control}
                      name={`contact_${index}`}
                      render={({ field }) => (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Mobile Number"
                          {...field}
                          value={inputFields[index][`contact`]}
                          disabled={flag === "edit"}
                          onChange={(e) => {
                            field.onChange(e);
                            const updatedFields = [...inputFields];
                            updatedFields[index] = {
                              ...updatedFields[index],
                              [`contact`]: e.target.value,
                            };
                            setInputFields(updatedFields);
                          }}
                        />
                      )}
                    ></Controller>
                  </div>
                  <div className="my-2">
                    <label className="mb-1">Address</label>
                    <Controller
                      control={control}
                      name={`address_${index}`}
                      render={({ field }) => (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address"
                          {...field}
                          value={inputFields[index][`address`]}
                          disabled={flag === "edit"}
                          onChange={(e) => {
                            field.onChange(e);
                            const updatedFields = [...inputFields];
                            updatedFields[index] = {
                              ...updatedFields[index],
                              [`address`]: e.target.value,
                            };
                            setInputFields(updatedFields);
                          }}
                        />
                      )}
                    ></Controller>
                  </div>
                  <div className="col">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => handleRemove(index)}
                      disabled={flag === "edit"}
                    >
                      Remove
                    </button>
                  </div>
                </>
              ))}

            {/* Upload Image */}
            <div className="mb-3">
              <label className="form-label">Upload Image</label>
              <br />
              <input
                className="form-control mb-2"
                type="file"
                id="formFile"
                name="files"
                disabled={flag === "edit"}
                {...register("upload_url", {
                  required: flag === "edit" ? false : true,
                  onChange: (e) => imageChange(e),
                })}
              />

              {errors.upload_url && (
                <p className="text-red-600">Image is required!</p>
              )}
              {progress > 0 && progress < 100 ? (
                <SlProgressBar value={progress}>{progress}%</SlProgressBar>
              ) : imgUrl !== "" ? (
                <span>{`${imgUrl}`}</span>
              ) : (
                flag === "edit" && <span>{`${imgUrl}`}</span>
              )}
            </div>

            {/* Submit Button */}
            <div className="mb-3">
              <button
              disabled={isSubmitting}
                type="submit"
                className="btn btn-primary"
                onClick={() => setSubmit(true)}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
        </div>
      </SlDrawer>

      {data?.length && !loader ? (
        <div className="birdviewWrapper">
          <ul className="birdview grid grid-cols-2 md:grid-cols-4 gap-4"> 
            {data.map((item, index) => {
              if (data.length !== index + 1) {
                return (
                  <li key={item.id}>
                    <div className="theme">
                      {item?.image_url ? (
                        <img src={item.image_url} alt="placeholder" />
                      ) : (
                        <img src={NoImage} alt="placeholder" />
                      )}
                      <div className="blur">
                        {item?.image_url ? (
                          <img src={item.image_url} alt="placeholder" />
                        ) : (
                          <img src={NoImage} alt="placeholder" />
                        )}
                      </div>
                      <div className="publisher">
                        {item?.newspaper_name ? (
                          <h6 style={getColors(item?.newspaper_name)}>
                            {item.newspaper_name}
                          </h6>
                        ) : null}
                        {item?.ad_type === "Local" ? (
                          <h6 className="local">{item.ad_type}</h6>
                        ) : item?.ad_type === "National" ? (
                          <h6 className="national">{item.ad_type}</h6>
                        ) : (
                          <h6 className="districts">{item.ad_type}</h6>
                        )}
                      </div>
                      <p className="location">
                        <img
                          src={LocationSVG}
                          alt="location_name"
                          title={item.location}
                        />
                        {getLocations(item.location)}
                      </p>
                      <p className="estimation">
                        Est Val: <strong>{item.estimated_value || 0}</strong>
                      </p>
                      {item.image_url ? (
                        <Button
                          className="previewBtn"
                          variant="neutral"
                          onClick={() => {
                            setImgSrc(item.image_url);
                            setOpen(true);
                          }}
                        >
                          Preview
                        </Button>
                      ) : null}
                    </div>
                    <div className="description">
                      {item?.page_no ? (
                        <p>
                          Page {item.page_no} : {formatDate(item.date)}
                        </p>
                      ) : (
                        <p>Page - : {formatDate(item.date)}</p>
                      )}
                      <h1>{item.campaign_name || " "}</h1>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <h5>Edition : {item.edition || " "}</h5>
                          <h5>Ad Format : {item.ad_format || " "} </h5>
                          <h5>Brand Name : {item.brand_name || " "} </h5>
                        </div>
                        <div>
                          {item?.dimensions?.area && item?.dimensions?.w && item?.dimensions?.h && <h5>Area : {item?.dimensions?.area +` (${item?.dimensions?.w} * ${item?.dimensions?.h})`|| " "}</h5>}
                          {!['null','undefined'].includes(item?.dimensions?.color) && <h5>Color : {item?.dimensions?.color ? "Color" :"B&W" || " "} </h5>}
                          {item?.dimensions?.price_per_unit && <h5>Price Per Sqcm : {item?.dimensions?.price_per_unit || " "} </h5>}
                        </div>
                      </div>
                    </div>

                    <div className="moreOptions">
                      {localStorage.getItem("role") === roles.b2b ? (
                        <div
                          className="option"
                          onClick={async () => {
                            setInitialRender(true);
                            handleShow("edit", item);
                            setFlag("edit");
                            setId(item.id);
                          }}
                        >
                          <img src={EditIcon} alt="" />
                          <h6>Edit</h6>
                        </div>
                      ) : null}
                      <div
                        className="option"
                        onClick={async () => {
                          setPreview(true);
                          setAdvDetails(JSON.parse(JSON.stringify(item.advertisers)));
                        }}
                      >
                        <img src={UserIcon} alt="" />
                        <h6>Adv</h6>
                      </div>
                      <div
                        className="option"
                        onClick={() => {
                          setShowDialog(item.id);
                        }}
                      >
                        <img src={LocationSVG} alt="" />
                        <h6>Details</h6>
                      </div>
                    </div>
                    <SlDialog
                      label="Details"
                      open={item.id === showDialog}
                      onSlAfterHide={() => setShowDialog(null)}
                    >
                      <>
                        <p>{getLocations(item.location)}</p>
                        <p>{item.clusters}</p>
                      </>
                    </SlDialog>
                  </li>
                );
              } else {
                return (
                  <li
                    ref={index === data.length - 1 ? lastItemRef : null}
                    key={item.id}
                  >
                    <div className="theme">
                      {item?.image_url ? (
                        <img src={item.image_url} alt="ads" />
                      ) : (
                        <img src={NoImage} alt="placeholder" />
                      )}
                      <div className="blur">
                        {item?.image_url ? (
                          <img src={item.image_url} alt="ads" />
                        ) : (
                          <img src={NoImage} alt="placeholder" />
                        )}
                      </div>
                      <div className="publisher">
                        {item?.newspaper_name ? (
                          <h6 style={getColors(item?.newspaper_name)}>
                            {item.newspaper_name}
                          </h6>
                        ) : null}
                        {item?.ad_type === "Local" ? (
                          <h6 className="local">{item.ad_type}</h6>
                        ) : item?.ad_type === "National" ? (
                          <h6 className="national">{item.ad_type}</h6>
                        ) : (
                          <h6 className="districts">{item.ad_type}</h6>
                        )}
                      </div>
                      <p className="location">
                        <img
                          src={LocationSVG}
                          alt="location_name"
                          title={item.location}
                        />
                        {getLocations([item.location])}
                      </p>
                      <p className="estimation">
                        Est Val: <strong>{item.estimated_value || 0}</strong>
                      </p>
                      {item.image_url ? (
                        <Button
                          className="previewBtn"
                          variant="neutral"
                          onClick={() => {
                            setImgSrc(item.image_url);
                            setOpen(true);
                          }}
                        >
                          Preview
                        </Button>
                      ) : null}
                    </div>
                    <div className="description">
                      {item?.page_no ? (
                        <p>
                          Page {item.page_no} : {formatDate(item.date)}
                        </p>
                      ) : (
                        <p>Page - : {formatDate(item.date)}</p>
                      )}
                      <h1>{item.campaign_name || " "}</h1>
                      <h5>Edition : {item.edition || " "}</h5>
                      <h5>Ad Format : {item.ad_format || " "} </h5>
                      <h5>Brand Name : {item.brand_name || " "} </h5>
                    </div>

                    <div className="moreOptions">
                      {localStorage.getItem("role") === roles.b2b ? (
                        <div
                          className="option"
                          onClick={async () => {
                            setInitialRender(true);
                            handleShow("edit", item);
                            setFlag("edit");
                            setId(item.id);
                          }}
                        >
                          <img src={EditIcon} alt="" />
                          <h6>Edit</h6>
                        </div>
                      ) : null}
                      <div
                        className="option"
                        onClick={async () => {
                          setPreview(true);
                          setAdvDetails(JSON.parse(JSON.stringify(item.advertisers)));
                        }}
                      >
                        <img src={UserIcon} alt="" />
                        <h6>Adv</h6>
                      </div>
                      <div
                        className="option"
                        onClick={() => {
                          setShowDialog(item.id);
                        }}
                      >
                        <img src={LocationSVG} alt="" />
                        <h6>Details</h6>
                      </div>
                    </div>
                    <SlDialog
                      label="Location Details"
                      open={item.id === showDialog}
                      onSlAfterHide={() => setShowDialog(null)}
                    >
                      <>
                        <p>{getLocations(item.location)}</p>
                        <p>{item.clusters}</p>
                      </>
                    </SlDialog>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      ) : !data?.length && !loader ? (
        <NoDataFound colspan="17" />
      ) : (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}
      {infLoader ? (
        <div className="w-full d-flex justify-center items-center">
          <TableLoader />
        </div>
      ) : null}

      {/* <Modal
        className="birdview-image-preview"
        show={open}
        onHide={() => setOpen(false)}
      >
        <Modal.Header closeButton>Image Preview</Modal.Header>
        <Modal.Body>
          <img src={imgSrc} alt="" />
        </Modal.Body>
      </Modal> */}
    <Modal 
          className="birdview-image-preview" 
          show={open} 
          onHide={() => setOpen(false)}
          size="xl"
        >
        <Modal.Header closeButton>
          <span className="text-base font-medium">Image Preview - Complete Edge Coverage</span>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="grid grid-cols-1 lg:grid-cols-6 gap-0">
            {/* Original Image */}
            <div className="lg:col-span-3 p-6 bg-gray-50">
              <div
                className="relative bg-white rounded-lg shadow-lg p-2"
                onMouseEnter={() => setShowMagnifier(true)}
                onMouseMove={handleMouseMove}
                onMouseLeave={() => setShowMagnifier(false)}
              >
                <img 
                  ref={imgRef}
                  src={imgSrc} 
                  alt="" 
                  className="w-full h-auto block rounded cursor-crosshair"
                />
              </div>
            </div>

            {/* Zoomed Panel - Shows ALL edges clearly */}
            <div className="lg:col-span-3 p-6 bg-gray-100 border-l border-gray-300">
              <div className="sticky top-4 bg-white rounded-lg shadow-xl">
                <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-3 rounded-t-lg">
                  <div className="flex items-center justify-between">
                    <span className="font-semibold">🔍 Zoomed View</span>
                    <span className="bg-white bg-opacity-20 px-2 py-1 rounded text-xs">
                      {zoomLevel}x
                    </span>
                  </div>
                  <p className="text-xs text-blue-100 mt-1">Hover anywhere - including edges</p>
                </div>
                
                {showMagnifier ? (
                  <div 
                    className="w-full h-96 rounded-b-lg overflow-hidden"
                    style={{
                      backgroundImage: `url(${imgSrc})`,
                      backgroundPosition: `${position.x}% ${position.y}%`,
                      backgroundSize: `${zoomLevel * 100}%`,
                      backgroundRepeat: 'no-repeat',
                      imageRendering: '-webkit-optimize-contrast',
                      filter: 'contrast(1.1)',
                    }}
                  />
                ) : (
                  <div className="w-full h-96 rounded-b-lg flex items-center justify-center bg-gray-50">
                    <div className="text-center">
                      <div className="text-4xl mb-2">👆</div>
                      <p className="text-gray-500 text-sm">Hover over image</p>
                      <p className="text-gray-400 text-xs mt-1">to see zoomed view</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
    </Modal>
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex gap-4 flex-wrap w-full">
            <div className="w-full">
              <Select
                placeholder="Select District"
                name="source"
                size="medium"
                value={selectedLocation}
                onChange={(selected) => {
                  setSelectedLocation(selected);
                  setData([]);
                  setCurrentPage(0);
                }}
                options={[...locations]}
              />
            </div>
            <div className="w-full">
              <Select
                className=""
                placeholder="Select Newspaper"
                name="source"
                size="medium"
                value={selectedNewspaper}
                onChange={(selected) => {
                  setSelectedNewspaper(selected || []);
                  setData([]);
                  setCurrentPage(0);
                }}
                options={[
                  ...newspaperData
                    .filter((item) => item.name !== "Way2news")
                    .map((item) => {
                      return { label: item.name, value: item.name };
                    }),
                ]}
                isMulti
              />
            </div>

            <div className="w-full"></div>
            <div className="w-full">
              <SlSelect
                placeholder="Select Brand Type"
                name="adType"
                size="medium"
                value={selectedBrandType}
                onSlChange={(e) => {
                  setSelectedBrandType(e.target.value);
                  setData([]);
                  setCurrentPage(0);
                }}
              >
                <SlOption key={0} value={"0"}>
                  All
                </SlOption>
                <SlOption key={1} value={"1"}>
                  National
                </SlOption>
                <SlOption key={2} value={"2"}>
                  Local
                </SlOption>
              </SlSelect>
            </div>

            <SlInput
              className="w-full"
              size="medium"
              placeholder="Newspaper/Edition/Adv Name "
              onSlInput={debounce(searchFilterOnChange, 500)}
            >
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
            <div className="border rounded-lg min-w-fit h-fit">
              <Datepicker
                classNames="form-input"
                value={dateRange}
                primaryColor={"cyan"}
                showShortcuts={true}
                useRange={true}
                configs={{
                  shortcuts: {
                    today: "today",
                    yesterday: "yesterday",
                    currentMonth: "currentMonth",
                    pastMonth: "lastMonth",
                  },
                }}
                onChange={handleDateRange}
              />
            </div>
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
      <SlDrawer
        label={"Advertiser Details"}
        open={preview}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          setPreview(false);
          setId("");
        }}
        style={{ "--size": "70vw" }}
      >
        <div className="flex justify-end mb-5"></div>
        <div className="overflow-x-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Address</th>
              </tr>
            </thead>
            {advDetails?.length && !loader ? (
              <tbody>
                {advDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.person_name || "-"}</td>
                      <td>{item.contact || "-"}</td>
                      <td>{item.address || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !advDetails?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </div>
      </SlDrawer>
    </>
  );
}

export default AlphaBirdview;